<template>
  <div :class="classes">
    {{ counter }}
  </div>
</template>

<script>
  export default {
    name: 'TextCounter',

    props: {
      text: {
        type: String,
        default: ''
      },

      limit: {
        type: Number,
        default: 250
      }
    },

    computed: {
      classes () {
        return {
          'over-limit': this.text.length > this.limit
        }
      },

      counter () {
        return `${this.text.length}/${this.limit}`
      }
    }
  }
</script>

<style lang="scss" scoped>
  .over-limit {
    color: red;
  }
</style>



// WEBPACK FOOTER //
// TextCounter.vue?2ca33e92